import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsKudoHighlightedSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M23.552 9.668c.125.316.186.655.179.995a2.43 2.43 0 01-.752 1.643c.163.33.248.695.247 1.063a2.47 2.47 0 01-1.289 2.16l-.172 2.395a2.744 2.744 0 01-2.739 2.545h-8.26l-.042.022-3.545-9.227.73-.386 3.309-6.36L12.28.33h.161a3.238 3.238 0 013.05 3.233c.002.162-.012.324-.042.483l-1.01 4.028h6.724a2.531 2.531 0 012.387 1.594zM.67 14.734l4.962-2.643.258-.14 3.545 9.227-5.21 2.782L.67 14.734z"
        fill=""
      />
    </svg>
  )
);
SvgActionsKudoHighlightedSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgActionsKudoHighlightedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsKudoHighlightedSmall;
